module.exports = __webpack_public_path__ + "static/img/2areaB_16.c6983c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_16.png
// module id = 1137
// module chunks = 1